/**
 * @description Hide the loader and change the top location
 * @param {string} url - New location url
 * @param {Window} window - window object
 */
export const hideLoaderAndChangeLocation = (url, window) => {
  if (window.app && window.app.loader) {
    window.app.loader.hide();
  }
  window.top.location.href = url;
};



// WEBPACK FOOTER //
// ./src/common/utilities/location.js